module.exports = __webpack_public_path__ + "static/media/green-mobile-medium-blob.e2e9e643.svg";